import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Esto es un plan de dieta?',
    a: 'No. El Método del 1% no se trata de restricción. Se trata de tiempos estratégicos, nutrición y cambios de estilo de vida que apoyan tus hormonas de forma natural.'
  }, {
    q: '¿Qué tan pronto veré resultados?',
    a: 'Muchas mujeres reportan más energía y menos hinchazón en los primeros 7 a 10 días. Un balance hormonal más profundo suele tomar entre 1 y 3 ciclos (30 a 90 días) de práctica constante.'
  }, {
    q: '¿Necesito comprar suplementos costosos?',
    a: 'Para nada. El método se basa completamente en alimentos, luz natural y hábitos de vida que son totalmente gratuitos. No necesitas invertir en suplementos para obtener resultados.'
  }, {
    q: '¿Es adecuado para la menopausia o perimenopausia?',
    a: 'Sí. Los principios fundamentales de balance de glucosa, ritmo circadiano y manejo del estrés aplican a mujeres en todas las etapas de la vida.'
  }, {
    q: '¿Cómo accedo al material?',
    a: 'Al comprar, recibirás un correo con acceso inmediato para descargar el e-book en tu teléfono, tablet o computadora. Es tuyo de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-cream" data-id="element-52">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-53">
        <div className="text-center mb-10 md:mb-16" data-id="element-54">
          <FadeIn data-id="element-55">
            <h2 className="font-serif text-4xl text-ink" data-id="element-56">¿Preguntas?</h2>
          </FadeIn>
        </div>

        <div className="space-y-2" data-id="element-57">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-58">
              <div className="border-b border-ink/10" data-id="element-59">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-60">
                  <span className="font-serif text-lg md:text-xl text-ink group-hover:text-sand-dark transition-colors pr-2" data-id="element-61">
                    {faq.q}
                  </span>
                  <span className="ml-6 flex-shrink-0 text-ink-light" data-id="element-62">
                    {openIndex === index ? <Minus className="w-5 h-5" data-id="element-63" /> : <Plus className="w-5 h-5" data-id="element-64" />}
                  </span>
                </button>

                <AnimatePresence data-id="element-65">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-66">
                      <p className="pb-6 text-ink-light font-light leading-relaxed" data-id="element-67">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}